import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Question from "../../images/icons/question.svg";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import { Button, Grid, Modal } from "@material-ui/core";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 270,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.24)",
    outline: "none",
    borderRadius: 8,
    padding: theme.spacing(2, 4, 3),
  },
  paperdos: {
    position: "absolute",
    width: 410,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.24)",
    outline: "none",
    borderRadius: 8,
    padding: theme.spacing(2, 4, 3),
  },
  accept: {
    background: "#E5E5E5",
    color: "#7EBDCE",
    marginRight: "5%",
    "&:hover": {
      background: "#E5E5E5",
    },
  },
  cancel: {
    background: "#7EBDCE",
    color: "white",
    "&:hover": {
      background: "#7EBDCE",
    },
  },
  text: {
    fontSize: 15,
    fontFamily: "Roboto",
    color: "#545353",
    textAlign: "center",
    margin: "25px 20px",
  },
  titleAlert: {
    fontSize: 24,
    textAlign: "center",
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#545353",
  },
  marginButton: {
    marginRight: 10,
  },
}));

const ModalConfirmBase = ({
  description,
  open,
  handleClick,
  handleClickOut,
  type,
  title,
  oneButtons,
  textButtonSubmit,
  threeButtons
}) => {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);

  const iconsAlert = (type) => {
    if (type === "WARNING")
      return  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "30%" }}>
      <path d="M36.0415 20.2084H43.9582V28.1251H36.0415V20.2084ZM36.0415 36.0417H43.9582V59.7918H36.0415V36.0417ZM39.9998 0.416748C18.1498 0.416748 0.416504 18.1501 0.416504 40.0001C0.416504 61.8501 18.1498 79.5834 39.9998 79.5834C61.8498 79.5834 79.5832 61.8501 79.5832 40.0001C79.5832 18.1501 61.8498 0.416748 39.9998 0.416748ZM39.9998 71.6667C22.5436 71.6667 8.33317 57.4563 8.33317 40.0001C8.33317 22.5438 22.5436 8.33342 39.9998 8.33342C57.4561 8.33342 71.6665 22.5438 71.6665 40.0001C71.6665 57.4563 57.4561 71.6667 39.9998 71.6667Z" fill="#646464"/>
      </svg>;
    if (type === "QUESTION")
      return <img src={Question} alt="" style={{ width: "30%" }} />;
    if (type === "SUCCESS")
      return (
        <CheckCircleOutlineOutlinedIcon
          style={{ width: "45%", color: "green", height: "30%" }}
        />
      );
  };

  const renderButtons = (
    oneButtons,
    textButtonSubmit,
    handleClick,
    handleClickOut,
    threeButtons
  ) => {
    if (oneButtons) {
      return (
        <Button
          className={classes.cancel}
          type="button"
          variant="contained"
          color="secondary"
          onClick={handleClick}
        >
          {textButtonSubmit ? textButtonSubmit : "Aceptar"}
        </Button>
      );
    }else{
      if(threeButtons){
        return(
          <>  
            <Grid container>
              <Grid container>
                <Button
                  className={classes.cancel}
                  style={{width: 340, marginBottom: 10}}
                  type={oneButtons ? "button" : "submit"}
                  variant="contained"
                  color="secondary"
                  onClick={handleClick}
                >
                  {textButtonSubmit ? textButtonSubmit : "Descargar orden de examen medico"}
                </Button>
              </Grid>
              <Grid container>
                <Button
                  className={classes.cancel}
                  style={{width: 340, marginBottom: 10}}
                  type={oneButtons ? "button" : "submit"}
                  variant="contained"
                  color="secondary"
                  onClick={handleClick}
                >
                  {textButtonSubmit ? textButtonSubmit : "Descargar orden de servicio colectivo"}
                </Button>
              </Grid>
              <Grid container>
                <Button
                  className={classes.cancel}
                  style={{width: 340, marginBottom: 10}}
                  type={oneButtons ? "button" : "submit"}
                  variant="contained"
                  color="secondary"
                  onClick={handleClick}
                >
                  {textButtonSubmit ? textButtonSubmit : "Descargar archivos adjuntos"}
                </Button>
              </Grid>
              <Grid container>
                <Button
                  className={classes.accept}
                  style={{width: 340, marginRight: 0}}
                  type="button"
                  variant="contained"
                  onClick={handleClickOut}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </>
        )
      }else{
        return(
          <>
            <Button
              className={classes.accept}
              type="button"
              variant="contained"
              onClick={handleClickOut}
            >
              Cancelar
            </Button>
  
            <Button
              className={classes.cancel}
              type={oneButtons ? "button" : "submit"}
              variant="contained"
              color="secondary"
              onClick={handleClick}
            >
              {textButtonSubmit ? textButtonSubmit : "Aceptar"}
            </Button>
          </>
        )
      }
    }
  };

  const bodyModal = (
    <div style={modalStyle} className={threeButtons ? classes.paperdos : classes.paper}>
      {iconsAlert(type)}
      {title ? <h1 className={classes.titleAlert}> {title} </h1> : null}
      <p className={classes.text}>{description}</p>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {renderButtons(
          oneButtons,
          textButtonSubmit,
          handleClick,
          handleClickOut,
          threeButtons
        )}
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        style={{ textAlign: "center" }}
        open={open}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {bodyModal}
      </Modal>
    </div>
  );
};

export default ModalConfirmBase;
